// useTooltip.ts
import { ref } from 'vue'

export const useFloatingTooltip = () => {
  const visible = ref(false)
  const text = ref('')
  const x = ref(0)
  const y = ref(0)

  function showTooltip(message: string, event: MouseEvent) {
    // console.debug('showTooltip', message, event, visible.value)

    const rect = (event.target as Element).getBoundingClientRect()
    const centerX = rect.left + rect.width / 2
    const centerY = rect.top + rect.height / 2
    text.value = message
    x.value = centerX
    y.value = centerY
    visible.value = true
  }

  function hideTooltip() {
    // console.debug('hideTooltip', visible.value)
    visible.value = false
  }

  return { visible, text, x, y, showTooltip, hideTooltip }
}
